import React from 'react'

export interface YearMonthPickerContextValue {
  onChange(yearMonth: string): unknown
  /** format like 2024-01 */
  value: string | null

  /** format like 2024-01 */
  focus: string | null
  setFocus(yearMonth: string | null): void

  transitionState: 'none' | 'toNext' | 'toPrev' | 'init'

  goToNextYear(): unknown
  goToPreviousYear(): unknown
}

export const YearMonthPickerContext = React.createContext<null | YearMonthPickerContextValue>(null)

export interface YearMonthPickerRootProps {
  children?: React.ReactNode
  value: YearMonthPickerContextValue
}

export function YearMonthPickerRoot({ children, value }: YearMonthPickerRootProps) {
  return <YearMonthPickerContext.Provider value={value}>{children}</YearMonthPickerContext.Provider>
}
